<template>
  <section>
    <h4 class="fs-20 font-medium mb-4">Price per trip</h4>

    <checkbox v-model="options.budgetOptions.min0"
      v-if="availableBudgetOptions['min0']"
      @change="$emit('filter-changed')">
      {{budgetRange[0]}} ({{ availableBudgetOptions['min0'] || 0 }})
    </checkbox>
    <checkbox v-model="options.budgetOptions.min1000"
      v-if="availableBudgetOptions['min1000']"
      @change="$emit('filter-changed')">
      {{budgetRange[1000]}} ({{ availableBudgetOptions['min1000'] || 0 }})
    </checkbox>
    <checkbox v-model="options.budgetOptions.min2000"
      v-if="availableBudgetOptions['min2000']"
      @change="$emit('filter-changed')">
      {{budgetRange[2000]}} ({{ availableBudgetOptions['min2000'] || 0 }})
    </checkbox>
    <checkbox v-model="options.budgetOptions.min3000"
      v-if="availableBudgetOptions['min3000']"
      @change="$emit('filter-changed')">
      {{budgetRange[3000]}} ({{ availableBudgetOptions['min3000'] || 0 }})
    </checkbox>
    <checkbox v-model="options.budgetOptions.min4000"
      v-if="availableBudgetOptions['min4000']"
      @change="$emit('filter-changed')">
      {{budgetRange[4000]}} ({{ availableBudgetOptions['min4000'] || 0 }})
    </checkbox>
    <checkbox v-model="options.budgetOptions.min5000"
      v-if="availableBudgetOptions['min5000']"
      @change="$emit('filter-changed')">
      {{budgetRange[5000]}} ({{ availableBudgetOptions['min5000'] || 0 }})
    </checkbox>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Checkbox from '../../core/Checkbox'
import currencyRanges from '../../../helpers/currencyRanges';

export default {
  components: {
    Checkbox
  },
  computed: {
    ...mapGetters(['availableBudgetOptions']),
    ...mapState(['currency']),
    budgetRange(){
      return currencyRanges[this.currency.code].liveaboard.filterLabel
    }
  },
  inject: ['options']
}
</script>